var map = {
	"./testimonial-aycap.png": "cf84",
	"./testimonial-dga.png": "7126",
	"./testimonial-dtac.png": "bd13",
	"./testimonial-dva.png": "e1f9",
	"./testimonial-ega.png": "a465",
	"./testimonial-finixtv.png": "dc84",
	"./testimonial-foodpanda.png": "4fcf",
	"./testimonial-ipst.png": "9b04",
	"./testimonial-learn.png": "0bda",
	"./testimonial-pfp.png": "43e4",
	"./testimonial-ptt.png": "292b",
	"./testimonial-rabbit.png": "462f",
	"./testimonial-roche.png": "28fa",
	"./testimonial-scg.png": "a6d2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e9f5";